import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ModuleGuard } from 'src/app/shared/guards/module.guard';
import { ReminderComponent } from './reminder/reminder.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        // canActivate:[ModuleGuard],
        data: {
          title: 'Dashboard',
          modules:['INSIGHT"']
        }
      },
      {
        path: 'reminder',
        component: ReminderComponent,
        // canActivate:[ModuleGuard],
        data: {
          title: 'Reminder',
          modules:['REMINDER"']
        }
      },
     
    ]
  },
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InsightRoutingModule { }
